<template>
	<side-window :tabs="tabs" :active="active" class="settings" title="Indstillinger" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div>
			<form-grid-layout>
				<div v-show="active == 'email'">
					<text-view :height="200" label="Skabelon for tilbud" v-model="model.email.quoteDefault" />
					<div class="edit__label">Vedhæft tilbud</div>
					<file-list-view v-model="model.email.quoteAtts" />					
				</div>
				<div v-show="active == 'email'">
					<text-view :height="200" label="Skabelon for ordre" v-model="model.email.orderDefault" />
					<div class="edit__label">Vedhæft ordrebekræftelse</div>
					<file-list-view v-model="model.email.orderAtts" />					
				</div>
				<div v-show="active == 'email'">
					<text-view :height="200" label="Signatur" v-model="model.email.signature" />					
				</div>
				<div v-show="active == 'text'">
					<string-view label="Afsender" v-model="model.text.sender" />
				</div>
				<div v-show="active == 'instructions'">
					<string-view :optional="true" v-for="(instr, i) in instructions" :key="i" :height="50" :label="instr.label" v-model="model.instructions[instr.name]" />
				</div>
				<div v-show="active == 'private'">
					<text-view :height="200" label="Tilbud (pdf)" v-model="model.private.quote.pdf" />					
				</div>
				<div v-show="active == 'private'">
					<text-view :height="200" label="Tilbud (e-mail)" v-model="model.private.quote.email" />					
				</div>
				<div v-show="active == 'private'">
					<text-view :height="200" label="Ordrebrkræftelse (pdf)" v-model="model.private.order.pdf" />					
				</div>
				<div v-show="active == 'private'">
					<text-view :height="200" label="Ordrebrkræftelse (e-mail)" v-model="model.private.order.email" />					
				</div>
				<div v-show="active == 'business'">
					<text-view :height="200" label="Tilbud (pdf)" v-model="model.business.quote.pdf" />					
				</div>
				<div v-show="active == 'business'">
					<text-view :height="200" label="Tilbud (e-mail)" v-model="model.business.quote.email" />					
				</div>
				<div v-show="active == 'business'">
					<text-view :height="200" label="Ordrebekræftelse (pdf)" v-model="model.business.order.pdf" />					
				</div>
				<div v-show="active == 'business'">
					<text-view :height="200" label="Ordrebekræftelse (e-mail)" v-model="model.business.order.email" />					
				</div>
				<div v-show="active == 'templates'">
					<window-list-view :value="templates" :controller="templateController" />				
				</div>
				<div v-for="(role, i) in roles" v-bind:key="'roles' + i" v-show="active == 'roles'">
					<div class="side-window__heading">
						{{ role.label }}
						<switch-view :name="role.name" v-model="model.roles" />
					</div>
				</div>
				<div v-show="active == 'economy'">
					<string-view label="Omkostning pr time pr mand" v-model="model.economy.cost.man" />
				</div>
				<div v-show="active == 'integrations'">
					<div class="side-window__heading">
						Trustpilot
						<switch-view v-model="model.integrations.trustpilot.enabled" />
					</div>
					<string-view v-show="model.integrations.trustpilot.enabled" label="E-mail" v-model="model.integrations.trustpilot.email" />
					<string-view :password="true" v-show="model.integrations.trustpilot.enabled" label="Adgangskode" v-model="model.integrations.trustpilot.password" />
				</div>
				<div v-show="active == 'integrations'">
					<div class="side-window__heading">
						e-conomic
						<switch-view v-model="model.integrations.economic.enabled" />
					</div>
					<string-view v-show="model.integrations.economic.enabled" label="ID" v-model="model.integrations.economic.id" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="save" />
		</div>
	</side-window>
</template>

<script>
	import SideWindow from '../../components/SideWindow'
	import FileListView from '../views/FileListView';

	import TemplateController from '../../components/TemplateController';

	import merge from '../functions/merge'

	export default {
		components: {
			sideWindow: SideWindow,
			fileListView: FileListView
		},
		data() {
			return {
				templateController: TemplateController,
				templates: [],
				active: 'email',
				dummy: '',
				departments: [],
				instructions: [],
				roles: [],
				model: {
					email: {
						quoteAtts: [],
						orderAtts: [],
						quoteDefault: '',
						orderDefault: '',
						signature: 'Mvh,<br>\n{name}<br>\n{title}<br>\nmoovr'
					},
					text: {
						sender: 'moovr'
					},
					instructions: {},
					private: {
						quote: {
							pdf: '',
							email: ''
						},
						order: {
							pdf: '',
							email: ''
						}
					},
					business: {
						quote: {
							pdf: '',
							email: ''
						},
						order: {
							pdf: '',
							email: ''
						}
					},
					roles: [],
					economy: {
						cost: {
							man: ''
						}
					},
					integrations: {
						economic: {
							enabled: false,
							id: ''
						},
						trustpilot: {
							enabled: false,
							email: '',
							password: ''
						}
					}
				}
			};
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'email',
						label: 'E-mail'
					},
					{
						name: 'text',
						label: 'SMS'
					},
					{
						name: 'instructions',
						label: 'Instruktioner'
					},
					{
						name: 'templates',
						label: 'Skabeloner'
					},
					{
						name: 'roles',
						label: 'Roller'
					},
					{
						name: 'economy',
						label: 'Økonomi'
					},
					{
						name: 'integrations',
						label: 'Integrationer'
					}
				];
			}
		}, 
		methods: {
			bum() {
				console.log('bum');
			},
			save() {
				console.log('save');

				var self = this;

				this.axios
					.put('/us/settings/', this.model)
					.then(function (r) {
						self.$emit('close');
					}, function () {
						console.log('ERROR');
					});
			},
			tabSelect(name, tabName) {
				console.log(tabName);
				this.active = tabName;
			},
			roleInput() {

			}
		},
		async mounted() {
			var self = this;

			this.axios
				.get('/us/settings/')
				.then(function (r) {
					self.model = merge(self.model, r.data);
				}, function () {
					console.log('ERROR');
				});

			this.axios
				.get('/tasks/instructions/')
				.then(function (r) {
					for (var i = 0; i < r.data._items.length; ++i) {
						if (!self.model.instructions.hasOwnProperty(r.data._items[i].name)) {
							self.model.instructions[r.data._items[i].name] = '';
						}
					}

					self.instructions = r.data._items;

					console.log(self.instructions);
				}, function () {
					console.log('ERROR');
				});

			var employeeRoles = (await this.axios.get('/employees/roles/')).data._items;
			var vehicleRoles = (await this.axios.get('/fleet/vehicles/roles/')).data._items;

			this.roles = employeeRoles.concat(vehicleRoles);
		}
	}
</script>

<style lang="scss">
	.settings {
		.edit__label {
			position: relative;
			pointer-events: none;
			left: 0;
			top: 0;
			font-size: 12px;
			color: #555963;
			margin-bottom: 10px;
		}
	}
</style>
